import React from 'react';
import styled from 'styled-components';
import Image from "@/components/common/Image";
import {getCssSizeValue, getHtmlFromRedactorField, getItemUrl} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import Link from "next/link";

const Wrapper = styled(Link)`
	width: 100%;
	cursor: pointer;
`
export const BlockImageWrapper = styled.div`
	width: 100%;
	height: 100%;
	cursor: pointer;
	position: relative;
	.image {
		height: 100%;
	}
`

export const ImageBlend = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 2;
	background-color: ${({theme}) => theme.colors.richBlue};
	opacity: ${({$opacity}) => $opacity === 0 ? 0 : `calc(${$opacity} / 100)`};
`

export const ImageTextContainer = styled.div`
	display: none;
    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		color: ${({theme}) => theme.colors.white};
		display: initial;
		width: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		padding: 0 ${getCssSizeValue(24, BREAKPOINTS.MOBILE)} ${getCssSizeValue(24, BREAKPOINTS.MOBILE)}; 
		z-index:3;
    }
	
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: 0 ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
	}
	span[style= "text-decoration: line-through;"] {
		text-decoration: none !important;
		background-color: ${({theme}) => theme.colors.barnRed};
		background-position: 20%;
		line-height: 35%;
		display: inline-block;
	}
`

const ImageTextLinkBlock = ({className, data}) => {
	const blendOpacity = data?.blendOpacity || 50;
	const imageUrl = data?.image?.url || '';
	const text = data?.text || ''
	const link = data?.link?.link || '';
	const itemUrl = getItemUrl(link);
	return (
		<Wrapper href={itemUrl} className={className}>
			<BlockImageWrapper>
				<ImageBlend $opacity={blendOpacity}/>
				<Image
					src={imageUrl}
					fit="cover"
					alt={'image'}
				/>
				<ImageTextContainer>
					<div className="typo-borna typo-borna-77" dangerouslySetInnerHTML={getHtmlFromRedactorField(text)}/>
				</ImageTextContainer>
			</BlockImageWrapper>
		</Wrapper>
	);
};

export default ImageTextLinkBlock;
